/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ListPageTopBar } from "@/components/layout/dashboard-layout";

import { ErrorBoundary } from "react-error-boundary";
import { Download, Plus, Save, Upload } from "lucide-react";
import { useMutations } from "./utils/react-hook/use-mutations";
import { ReactForm, ReactTableSkelton, TreeStructure } from "./utils";
import { Fragment } from "react/jsx-runtime";
import ErrorFallback from "@/components/shared/error-fallback";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { RecordNotFound } from "@/components/shared/record-not-found";
import { useUserInfo } from "@/global-data/use-user-info";

export const Synonym = () => {
  const {
    listData,
    onFormSubmit,
    skeltonLoading,
    open,
    onOpenChange,
    onListChange,
    onTreeMutation,
    onTreeFormEdit,
    erpListData,
    updateList,
    manageUpdateData,
    importDocument,
    exportDocument,
    order_type,
    sortingTree,
    isSaveEnabled,
    companyData,
  } = useMutations();

  const { activePermission } = useUserInfo();

  console.log({ companyData });

  return (
    <Fragment>
      <div className="flex flex-col gap-5">
        <ListPageTopBar title="Synonym">
          <>
            <Button
              variant={"action"}
              disabled={activePermission?.update !== true}
              className=" relative cursor-pointer"
            >
              <Download /> Import
              <input
                type="file"
                onChange={(e) => importDocument(e?.target?.files?.[0] || null)}
                className="absolute left-0 top-0 w-full h-full opacity-0 cursor-pointer"
              />
            </Button>
            <Button variant={"action"} onClick={() => exportDocument()}>
              <Upload />
              Export
            </Button>
            <ConditionRenderer condition={listData?.length !== 0}>
              {activePermission?.update ? (
                <Button
                  className="text-green-500 border-green-500 py-2 h-auto"
                  variant={"outline"}
                  // disabled={updateList?.length === 0}
                  disabled={updateList?.length === 0 && !isSaveEnabled}
                  onClick={() => {
                    onTreeMutation({
                      type: null,
                      actionType: "save",
                      key: null,
                      treeId: null,
                    });
                  }}
                >
                  <Save /> Save
                </Button>
              ) : null}
            </ConditionRenderer>
            {activePermission?.create ? (
              <Button
                className=""
                variant={"outline"}
                onClick={() => {
                  onOpenChange(true);
                }}
              >
                <Plus /> Create Synonym
              </Button>
            ) : null}
          </>
        </ListPageTopBar>

        {skeltonLoading ? (
          <ReactTableSkelton />
        ) : (
          <ErrorBoundary
            fallbackRender={({ error, resetErrorBoundary }) => (
              <ErrorFallback
                error={error}
                errorInfo={error.stack || ""}
                resetErrorBoundary={resetErrorBoundary}
              />
            )}
          >
            <ConditionRenderer condition={listData?.length === 0}>
              <Card className="pb-[130px] flex flex-col items-center">
                <RecordNotFound />
                <Button
                  className="mt-5"
                  onClick={() => {
                    onOpenChange(true);
                  }}
                >
                  <Plus /> Create Synonym
                </Button>
              </Card>
              <TreeStructure
                data={listData}
                onChange={onListChange}
                erpListData={erpListData}
                manageUpdateData={manageUpdateData}
                updateList={updateList}
                orderTypeList={order_type}
                sortingTree={sortingTree}
                onTreeMutation={(prop: any) => {
                  onTreeMutation(prop);
                }}
                onTreeFormSubmit={(prop: any, prop2: any) => {
                  onTreeFormEdit(prop, prop2);
                }}
                support_multi_doc_type={
                  companyData?.settings?.support_multi_doc_type
                }
              />
            </ConditionRenderer>
          </ErrorBoundary>
        )}
      </div>

      <ReactForm
        formData={{}}
        open={open}
        onOpenChange={(prop) => onOpenChange(prop)}
        onFormSubmit={onFormSubmit}
        order_type={order_type}
      />
      {/* <ConditionRenderer condition={formType ? true : false}>
        <TreeMutationForm
          formData={{}}
          open={formType ? true : false}
          type={formType}
          onOpenChange={() => setFormType(undefined)}
          onFormSubmit={onTreeFormSubmit}
          isUpdate={activeRecordData?.actionType === "edit" ? true : false}
          defaultValue={activeRecordData?.value}
        />
      </ConditionRenderer> */}
    </Fragment>
  );
};
